import { createActions, createReducer } from 'reduxsauce'

import ArquivosContratoService from '../../servicos/ArquivosContratoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaArquivosAssinadosEmpenhoCredorInicio: [],
    buscaArquivosAssinadosEmpenhoCredorSucesso: ['arquivosAssinadosEmpenhoCredor'],
    buscaArquivosAssinadosEmpenhoCredorErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaArquivosAssinadosEmpenhoCredor = filtro => {
    return dispatch => {
        dispatch(Creators.buscaArquivosAssinadosEmpenhoCredorInicio())
        let serv = new ArquivosContratoService()
        return serv
            .consultarArquivosAssinados(filtro)
            .then(response => dispatch(Creators.buscaArquivosAssinadosEmpenhoCredorSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaArquivosAssinadosEmpenhoCredorErro(error)))
    }
}

const buscaArquivosAssinadosEmpenhoCredorInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaArquivosAssinadosEmpenhoCredorErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaArquivosAssinadosEmpenhoCredorSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.arquivosAssinadosEmpenhoCredor, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_ARQUIVOS_ASSINADOS_EMPENHO_CREDOR_INICIO]: buscaArquivosAssinadosEmpenhoCredorInicio,
    [Types.BUSCA_ARQUIVOS_ASSINADOS_EMPENHO_CREDOR_ERRO]: buscaArquivosAssinadosEmpenhoCredorErro,
    [Types.BUSCA_ARQUIVOS_ASSINADOS_EMPENHO_CREDOR_SUCESSO]: buscaArquivosAssinadosEmpenhoCredorSucesso,
})
